import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { ValidationService } from './../../validation.service';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthenticationService } from './../../_services/index';
import { AuthService } from 'angular4-social-login';
import { SocialUser } from 'angular4-social-login';
import { Subscription } from 'rxjs/Subscription';
import { UserService } from './../../_services/index';
import { FormDoneService } from '../../_services/form-done.service';
import * as jwt_decode from 'jwt-decode';
//import { FacebookLoginProvider, GoogleLoginProvider } from 'angular4-social-login';
import { CookieService } from 'ngx-cookie';
import { StudentInfoService } from '../../_services/student-info.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css'],
  providers: [AuthenticationService, FormDoneService]
})
export class LoginComponent implements OnInit, OnDestroy {
  ErrorMassage: any;
  loginForm: any;
  currentUser = [];
  cUser: any;
  returnUrl: string;
  public errorFlag = false;
  loading = false;
  formChangeSub: Subscription;
  email;
  password;
  confirm_password;
  firstname;
  lastname;
  username;
  getdataSub: Subscription;
  user: SocialUser;
  loginSub: Subscription;

  constructor(
    private formBuilder: FormBuilder,
    private stdapi: StudentInfoService,
    private router: Router,
    private route: ActivatedRoute,
    private loginservice: AuthenticationService,
    private api: FormDoneService,
    private authService: AuthService,
    private userservice: UserService,
    private _cookieService: CookieService
  ) {

    const authResult = localStorage.getItem('token');
    if (authResult) {
      const decoded = jwt_decode(authResult);
      const exp = decoded.exp;
      const ctime = Date.now() / 1000;
      const ctimefix = parseInt(ctime.toFixed(0));
      if (exp < ctimefix) {
        localStorage.removeItem('token');
        localStorage.removeItem('currentUser');
      } else {
        this.router.navigate(['/']);
      }
    }
  }

  ngOnInit() {
    this.validateLoginForm();
  }

  ngOnDestroy() {
    if (this.formChangeSub) {
      this.formChangeSub.unsubscribe();
    }
    if (this.loginSub)  {
      this.loginSub.unsubscribe();
    }
    if (this.getdataSub) {
      this.getdataSub.unsubscribe();
    }
  }

  validateLoginForm() {
    this.loginForm = this.formBuilder.group({
      'email': ['', [Validators.required]],
      'password': ['', [Validators.required]]
    });
  }

  loginUser() {

    this.returnUrl = localStorage.getItem('return-url');
    console.log(this.returnUrl);
    localStorage.removeItem('return-url');

    this.loading = true;
    this.loginSub = this.loginservice.authenticate(
      this.loginForm.value.email, this.loginForm.value.password
    ).subscribe(
      (dataResponse) => {
        const response = dataResponse;
        if (response.success === 1 && response.statusCode === 200) {
          this.errorFlag = false;
          localStorage.setItem('currentUser', JSON.stringify(response.data));
          const token = response.data.token;
          localStorage.setItem('token', 'Bearer ' + token);
          const decoded = jwt_decode(token);
          const exp = decoded.exp;
          const date = new Date(exp * 1000);
          const getDomainName = this.loginservice.getDomainName();
          const parts = window.location.hostname.split(getDomainName);

          const countLength = parts.length;

          const subdomain = parts.shift();
          if (countLength === 1) {
            this._cookieService.put('token', 'Bearer ' + token, {
              domain: getDomainName,
              expires: date
            });
          }
          if (countLength === 2) {
            this._cookieService.put('token', 'Bearer ' + token, {
              domain: getDomainName,
              expires: date
            });
          }
          this.errorFlag = false;
          this.loading = false;
          this.getdataSub = this.api.getFormData('Bearer ' + token)
          .subscribe(responsedata => {
            const formdata = responsedata.data;
            const personalinformation = formdata.personalinformation;
            const academicinformation = formdata.academicinformation;
            const backgroundinformation = formdata.backgroundinformation;
            const priorhighereducation = formdata.priorhighereducation;
            const futurecollegeplans = formdata.futurecollegeplans;
            const academiccareergoals = formdata.academiccareergoals;
            const extracurrucaullar = formdata.extracurrucaullar;
            const employment = formdata.employment;
            const profileupload = formdata.profileupload;

            if(this.returnUrl){
              this.router.navigate([this.returnUrl]);
            }
            else{
              if (profileupload > 0) {
                this.router.navigate(['/user-dashboard']);
              } else {
                this.router.navigate(['/profile-upload']);
              }
            }
            
          });
        }
      },
      error => {
        this.loading = false;
        // console.log(error.success);
        let errordata = error;
        if (this.isJSON(error._body)) {
          errordata = JSON.parse(error._body);
        } else {
          errordata = error;
        }
        if (errordata.success === 0) {
          this.ErrorMassage = errordata.message;
          this.errorFlag = true;
        }

      }
    );
  }

  isJSON(str) {
    try {
        return (JSON.parse(str) && !!str);
    } catch (e) {
        return false;
    }
  }

  /* signInWithGoogle(): void {
    this.authService.signIn(GoogleLoginProvider.PROVIDER_ID);
    this.formChangeSub = this.authService.authState.subscribe((user) => {
      //this.user = user;
      console.log(user);
      //return false;
      if(user) {
        console.log(user);
        this.email = user.email;
        this.password = user.id
        this.confirm_password = user.id
        this.firstname = user.firstName;
        this.lastname = user.lastName ;
        this.username  = user.name;
        this.userservice.socialSignup(
            this.email, this.password,
            this.confirm_password, this.firstname,
            this.lastname, this.username
          ).subscribe(
            (dataResponse) => {

              console.log(dataResponse);
              const response = dataResponse;
              if (response.success === 1 && response.statusCode === 200) {
                this.errorFlag = false;
                this.loading = false;
                this.ErrorMassage = response.message;

                this.loginservice.socialauthenticate(
                  this.email, this.password
                ).subscribe(
                  (dataResponse) => {
                    const response = dataResponse;
                    if (response.success === 1 && response.statusCode === 200) {
                      this.errorFlag = false;
                      localStorage.setItem('currentUser', JSON.stringify(response.data));
                      const token = response.data.token;
                      localStorage.setItem('token', 'Bearer ' + token);
                      
                      const decoded = jwt_decode(token);
                      const exp = decoded.exp;
                      const date = new Date(exp * 1000);
                      const getDomainName = this.loginservice.getDomainName();
                      const parts = window.location.hostname.split(getDomainName);
            
                      const countLength = parts.length;
            
                      const subdomain = parts.shift();
                      if (countLength === 1) {
                        this._cookieService.put('token', 'Bearer ' + token, {
                          domain: getDomainName,
                          expires: date
                        });
                      }
                      if (countLength === 2) {
                        this._cookieService.put('token', 'Bearer ' + token, {
                          domain: getDomainName,
                          expires: date
                        });
                      }
                      
                      this.errorFlag = false;
                      this.loading = false;
                      this.router.navigate(['/user-dashboard']);
                    }
                  },
                  error => {
                    this.loading = false;
                    const errordata = JSON.parse(error._body);
                    if (errordata.success === 0) {
                      this.ErrorMassage = errordata.message;
                      this.errorFlag = true;
                    }
                  }
                );
              }
          },
          error => {
            this.loading = false;
            const errordata = JSON.parse(error._body);

            console.log(errordata);
            if (errordata.success === 0 && errordata.message === 'You are already registered!') {
              this.loginservice.socialauthenticate(
                this.email, this.password
              ).subscribe(
                (dataResponse) => {
                  const response = dataResponse;
                  if (response.success === 1 && response.statusCode === 200) {
                    this.errorFlag = false;
                    localStorage.setItem('currentUser', JSON.stringify(response.data));
                    const token = response.data.token;
                    localStorage.setItem('token', 'Bearer ' + token);

                    const decoded = jwt_decode(token);
                    const exp = decoded.exp;
                    const date = new Date(exp * 1000);
                    const getDomainName = this.loginservice.getDomainName();
                    const parts = window.location.hostname.split(getDomainName);
          
                    const countLength = parts.length;
          
                    const subdomain = parts.shift();
                    if (countLength === 1) {
                      this._cookieService.put('token', 'Bearer ' + token, {
                        domain: getDomainName,
                        expires: date
                      });
                    }
                    if (countLength === 2) {
                      this._cookieService.put('token', 'Bearer ' + token, {
                        domain: getDomainName,
                        expires: date
                      });
                    }

                    this.errorFlag = false;
                    this.loading = false;
                    this.router.navigate(['/user-dashboard']);
                  }
                },
                error => {
                  this.loading = false;
                  const errordata = JSON.parse(error._body);
                  if (errordata.success === 0) {
                    this.ErrorMassage = errordata.message;
                    this.errorFlag = true;
                  }
                }
              );

            }
          }
        );
      }
    });
  }

  signInWithFB(): void {
    this.authService.signIn(FacebookLoginProvider.PROVIDER_ID);
    this.formChangeSub = this.authService.authState.subscribe((user) => {
      console.log(user);
      // this.user = user;
      if (user) {
        console.log(user);
        this.email = user.email;
        this.password = user.id;
        this.confirm_password = user.id;
        this.firstname = user.firstName;
        this.lastname = user.lastName ;
        this.username  = user.name;
        this.userservice.socialSignup(
            this.email, this.password,
            this.confirm_password, this.firstname,
            this.lastname, this.username
          ).subscribe(
            (dataResponse) => {

              console.log(dataResponse);
              const response = dataResponse;
              if (response.success === 1 && response.statusCode === 200) {
                this.errorFlag = false;
                this.loading = false;
                this.ErrorMassage = response.message;

                this.loginservice.socialauthenticate(
                  this.email, this.password
                ).subscribe(
                  (dataResponse) => {
                    const response = dataResponse;
                    if (response.success === 1 && response.statusCode === 200) {
                      this.errorFlag = false;
                      localStorage.setItem('currentUser', JSON.stringify(response.data));
                      const token = response.data.token;
                      localStorage.setItem('token', 'Bearer ' + token);

                      const decoded = jwt_decode(token);
                      const exp = decoded.exp;
                      const date = new Date(exp * 1000);
                      const getDomainName = this.loginservice.getDomainName();
                      const parts = window.location.hostname.split(getDomainName);
            
                      const countLength = parts.length;
            
                      const subdomain = parts.shift();
                      if (countLength === 1) {
                        this._cookieService.put('token', 'Bearer ' + token, {
                          domain: getDomainName,
                          expires: date
                        });
                      }
                      if (countLength === 2) {
                        this._cookieService.put('token', 'Bearer ' + token, {
                          domain: getDomainName,
                          expires: date
                        });
                      }

                      this.errorFlag = false;
                      this.loading = false;
                      this.router.navigate(['/user-dashboard']);
                    }
                  },
                  error => {
                    this.loading = false;
                    const errordata = JSON.parse(error._body);
                    if (errordata.success === 0) {
                      this.ErrorMassage = errordata.message;
                      this.errorFlag = true;
                    }
                  }
                );
              }
          },
          error => {
            this.loading = false;
            const errordata = JSON.parse(error._body);

            console.log(errordata);
            if (errordata.success === 0 && errordata.message === 'You are already registered!') {
              this.loginservice.socialauthenticate(
                this.email, this.password
              ).subscribe(
                (dataResponse) => {
                  const response = dataResponse;
                  if (response.success === 1 && response.statusCode === 200) {
                    this.errorFlag = false;
                    localStorage.setItem('currentUser', JSON.stringify(response.data));
                    const token = response.data.token;
                    localStorage.setItem('token', 'Bearer ' + token);

                    const decoded = jwt_decode(token);
                    const exp = decoded.exp;
                    const date = new Date(exp * 1000);
                    const getDomainName = this.loginservice.getDomainName();
                    const parts = window.location.hostname.split(getDomainName);
          
                    const countLength = parts.length;
          
                    const subdomain = parts.shift();
                    if (countLength === 1) {
                      this._cookieService.put('token', 'Bearer ' + token, {
                        domain: getDomainName,
                        expires: date
                      });
                    }
                    if (countLength === 2) {
                      this._cookieService.put('token', 'Bearer ' + token, {
                        domain: getDomainName,
                        expires: date
                      });
                    }

                    this.errorFlag = false;
                    this.loading = false;
                    this.router.navigate(['/user-dashboard']);
                  }
                },
                error => {
                  this.loading = false;
                  const errordata = JSON.parse(error._body);
                  if (errordata.success === 0) {
                    this.ErrorMassage = errordata.message;
                    this.errorFlag = true;
                  }
                }
              );

            }
          }
        );
      }
    });
  } */

  /* checkAuth() {

    this.formChangeSub = this.authService.authState.subscribe((user) => {
      //this.user = user;
      if(user) {
        console.log(user);
      }
    });

  } */

  /* signOut(): void {
    this.authService.signOut();
  } */

}



// WEBPACK FOOTER //
// /home/aschmidt/websites/onefuturecv.org/onefuture-frontend/src/app/pages/login/login.component.ts